import { render, staticRenderFns } from "./detailData.vue?vue&type=template&id=40ac714b&scoped=true"
import script from "./detailData.vue?vue&type=script&lang=js"
export * from "./detailData.vue?vue&type=script&lang=js"
import style0 from "./detailData.vue?vue&type=style&index=0&id=40ac714b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ac714b",
  null
  
)

export default component.exports